import { datadogLogs } from '@datadog/browser-logs'
import { Redirect } from 'react-router-dom'
import { useParams } from 'react-router'
import { ReactElement, useEffect, useState } from 'react'

import apiClientService from '../../utils/api'
import { UserInfo } from '../../utils/auth/authContext'
import { AuthLoading } from '../../utils/auth/AuthFailure'

import useAuth from '../../utils/auth/useAuth'
import { normalizeLocale } from '../../utils/locale'

const Login = (): ReactElement => {
  const { locale } = useParams<{ locale: string }>()

  const { isLoading, isAuthenticated, user } = useAuth()

  const [userLocale, setUserLocale] = useState<string>(null)

  useEffect(() => {
    if (isAuthenticated && user) {
      const currentLocale = getLocale(user, locale)
      apiClientService
        .logout(currentLocale)
        .catch((error: unknown) => {
          datadogLogs.logger.error('Backend login context reset failed', {
            error,
          })
        })
        .finally(() => setUserLocale(currentLocale))
    }
  }, [isAuthenticated, user, locale])

  return !isLoading && userLocale ? (
    <Redirect to={`/${userLocale}/showroom`} />
  ) : (
    <AuthLoading />
  )
}

const getLocale = (user: UserInfo, locale: string) => {
  if (locale) {
    return normalizeLocale(locale)
  } else {
    return user.userLocale
  }
}

export default Login
